<template>
  <form @submit.prevent>
    <div>
      <b-tabs v-if="showLibraryItems" justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
        <b-tab :active="showLibraryItems">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">{{ $t("common.library") }}</span>
          </template>

          <!-- <div class="pl-5 pr-5">
            <recommendation-items
              v-if="selectedDepartment"
              rightPanelId="sidebar-process-recommendation"
              level="process"
              organizationScopedState="organizationDepartmentProcess"
              libraryScopedState="process"
              @interceptForSetParent="interceptForSetParent"
              :id="selectedDepartment._id"
            />
          </div> -->

          <LibraryItems
            rightPanelId="sidebar-new-process"
            organizationScopedState="organizationDepartmentProcess"
            libraryScopedState="process"
            @interceptForSetParent="interceptForSetParent"
            libraryScopedStateCategory="processCategory"
          />
        </b-tab>

        <b-tab :active="isEditMode">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="far fa-user"></i>
            </span>
            <span class="d-none d-sm-inline-block">
              <span v-if="isEditMode">{{ $t("common.update") }}</span>
              <span v-else>{{ $t("process.new") }}</span>
            </span>
          </template>

          <sweet-input
            :isValid="!$v.form.name.$error"
            @input="$v.form.name.$touch()"
            v-model="form.name"
            type="text"
            layout="vertical"
            :placeholder="$t('process.name')"
            :label="$t('process.name')"
          />

          <div class="col-mr-5 mt-3">
            <right-panel
              class="float-right mt-1 "
              id="sidebar-new-process-category"
              width="650px"
              :icon="'mdi mdi-plus'"
              :text="$t('process-category.new')"
              @hidden="rightPanelClosed"
            >
              <div class="pl-5 pr-5">
                <Form :hide-library="true" @onSave="onFormSave" />
              </div>
            </right-panel>
          </div>

          <h6 class="mt-4">{{ $t("process-category.text") }}</h6>
          <filter-select
            id="categoryFilter"
            ref="categoryFilter"
            :placeholder="$t('process-category.text')"
            :multiple="false"
            @filter="onCategorySearch"
            :selected="form.category"
            @changed="onCategorySelect"
          />

          <h6 class="mt-4">{{ $t("process.admin") }}</h6>

          <organization-member-select @onAclSelect="onProcessAdminSelect" />
          <!-- :permissionFilter="['ORGANIZATION_ADMIN']" -->

          <h6 class="mt-4">{{ $t("department.text") }}</h6>
          <filter-select
            id="departmentFilter"
            ref="departmentFilter"
            :placeholder="$t('department.text')"
            :multiple="false"
            @filter="onSearch"
            :selected="form.department"
            @changed="onSelect"
          />

          <label class="mt-4">{{ $t("common.description") }}</label>
          <textarea v-model="form.description" class="form-control mb-4" :placeholder="$t('common.description')"></textarea>

          <sweet-button
            @click="save()"
            type="submit"
            :loading="isUpdating"
            :disabled="isUpdating || $v.$invalid"
            variant="success"
            icon="mdi mdi-check"
            size="sm"
            buttonClass="mt-2"
          >
            {{ $t("common.save") }}
          </sweet-button>
        </b-tab>
      </b-tabs>

      <div v-else>
        <h2>
          <span v-if="!showLibraryItems && isEditMode">{{ entityName }} {{ $t("common.update") }}</span>
          <span v-else>{{ $t("process.new") }}</span>
        </h2>

        <sweet-input
          :isValid="!$v.form.name.$error"
          @input="$v.form.name.$touch()"
          v-model="form.name"
          type="text"
          layout="vertical"
          :placeholder="$t('process.name')"
          :label="$t('process.name')"
        />
        <h6 class="mt-4">{{ $t("process.admin") }}</h6>

        <organization-member-select @onAclSelect="onProcessAdminSelect" :selected="admin" />
        <!-- :permissionFilter="['ORGANIZATION_ADMIN']"  -->

        <h6 class="mt-4">{{ $t("process-category.text") }}</h6>
        <filter-select
          v-if="form && form._id"
          id="categoryFilter"
          ref="categoryFilter"
          :placeholder="$t('process-category.text')"
          :multiple="false"
          @filter="onCategorySearch"
          :selected="form.process.category"
          @changed="onCategorySelect"
        />
        <filter-select
          v-else
          id="categoryFilter"
          ref="categoryFilter"
          :placeholder="$t('process-category.text')"
          :multiple="false"
          @filter="onCategorySearch"
          :selected="form.category"
          @changed="onCategorySelect"
        />

        <h6 class="mt-4">{{ $t("department.text") }}</h6>

        <filter-select
          id="departmentFilter1"
          ref="departmentFilter1"
          :placeholder="$t('department.text')"
          :multiple="false"
          @filter="onSearch"
          :selected="form.department"
          @changed="onSelect"
        />

        <label class="mt-4">{{ $t("common.description") }}</label>
        <textarea v-model="form.description" class="form-control mb-4" :placeholder="$t('common.description')"></textarea>

        <div v-if="form && form._id">
          <b-form-checkbox v-model="changeInAllHierarchy" name="check-button" switch class="switch d-inline"></b-form-checkbox>
          <label class="switch">{{ $t("common.change-in-all-hierarchy") }}</label>
        </div>
        <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
          {{ $t("common.save") }}
        </sweet-button>

        <sweet-button @click="cancel()" variant="secondary" icon="mdi mdi-cancel" size="sm" buttonClass="mt-2 ml-2">
          {{ $t("common.cancel") }}
        </sweet-button>
      </div>
      <hr />
    </div>
  </form>
</template>

<script>
import LibraryItems from "@cc/library-items";
import OrganizationMemberSelect from "@cc/organization-member-select";
import RecommendationItems from "@cc/recommendation-items";

import SweetTextarea from "@c/form/sweet-textarea";
import { maxLength, minLength, required } from "vuelidate/lib/validators";
import Form from "../process/organization-process-category-form.vue";

export default {
  props: ["hide-library", "reloadAfterSave"],
  components: {
    RecommendationItems,
    OrganizationMemberSelect,
    LibraryItems,
    Form,
    SweetTextarea,
  },
  data() {
    return {
      form: { name: undefined, admins: undefined, department: undefined },
      changeInAllHierarchy: false,
      formError: undefined,
      entityName: undefined,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
      department: {
        required,
      },
      admins: {
        required,
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        if (!v || Object.keys(v).length === 0) return;

        this.form = { ...v, ...this.prepareFormForEdit(v), _id: v._id };
        this.entityName = this.form.name;
      },
    },
    copingEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        if (!v || Object.keys(v).length === 0) return;

        this.form = { ...v, ...this.prepareFormForEdit(v), _id: v._id };
        this.entityName = this.form.name;
      },
    },
    selectedDepartment: {
      deep: true,
      immediate: true,
      handler(v) {
        this.onSelect(v);
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters["organizationDepartmentProcess/isUpdating"];
    },
    editedEntity() {
      return this.$store.getters["organizationDepartmentProcess/editedEntity"];
    },
    copingEntity() {
      return this.$store.getters["organizationDepartmentProcess/copingEntity"];
    },
    isEditMode() {
      return this.$store.getters["organizationDepartmentProcess/isEditMode"];
    },
    showLibraryItems() {
      return !this.hideLibrary && !this.isEditMode && !this.isCoping;
    },
    isCoping() {
      return this.$store.getters["organizationDepartmentProcess/isCoping"];
    },
    selectedDepartment() {
      return this.$store.getters["organizationDepartment/selectedEntity"];
    },
    admin() {
      if (this.form.admins?.length == 0) {
        return undefined;
      }
      if (this.form.admins && this.form.admins[0].account) {
        return this.form.admins[0].account;
      } else if (this.form._id) {
        return {
          _id: this.form.admins[0].accountId,
          name: this.form.admins[0].name,
          email: this.form.admins[0].email,
          avatar: this.form.admins[0].avatar,
        };
      }
    },
  },
  mounted() {},
  methods: {
    async save() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        const { data } = await this.$store.dispatch("organizationDepartmentProcess/save", { payload: this.form, changeInAllHierarchy: this.changeInAllHierarchy });

        this.$store.commit("organizationDepartmentProcess/editedEntity", data);

        this.form = {};
        this.$toast.success(this.$t("common.success"));
        this.$root.$emit("bv::toggle::collapse", "sidebar-new-process");
        this.$emit("onSave", data);
        if (this.reloadAfterSave) {
          location.reload();
        }
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    cancel() {
      this.$store.commit("organizationDepartmentProcess/editedEntity");
      this.$store.commit("organizationDepartmentProcess/copingEntity");
      // this.$store.dispatch("organizationDepartmentProcess/resetForm");
    },
    async onSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationDepartment/paginateForSearch`, {
        options: { limit: 20 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onSelect(item) {
      this.form = { ...this.form, department: item };
    },
    rightPanelClosed() {
      this.$refs.categoryFilter.reset();
    },
    async onCategorySearch(value, callback) {
      const response = await this.$store.dispatch(`processCategory/paginate`, {
        options: { limit: 20 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onFormSave(item) {
      this.form = { ...this.form, category: { ...item, _id: item.libraryItem } };
    },
    onCategorySelect(item) {
      this.form = { ...this.form, category: item };
    },
    interceptForSetParent(payload) {
      payload.department = this.selectedDepartment;
    },

    onProcessAdminSelect(item) {
      this.form = { ...this.form, admins: [item] };
    },
  },
};
</script>
